<template>
<label class="checkbox-container" :class="{'disabled' : disabled}" :for="id">
  <input type="checkbox" v-model="value" :id="id" :disabled="disabled" v-bind="$attrs">{{checkBoxLabel}}
  <span class="checkmark"></span>
</label>
</template>
<script>
export default {
  name: 'CustomCheckBox',
  props:['checkBoxLabel', 'id', 'disabled']
};
</script>
<style lang="scss" scoped>
</style>